import React from "react";
import classNames from "classnames";

import { useSidebarNavOptional } from "./SidebarNavContext";

const Main = ({ className, children }) => {
  const sidebarNav = useSidebarNavOptional();

  return (
    <div className={classNames("main", className)}>
      {sidebarNav ? (
        <div className="main-mobile-toolbar d-flex d-lg-none align-items-center">
          <button
            type="button"
            className="sidebar-button main-mobile-toolbar__menu"
            onClick={sidebarNav.toggleMobileSidebar}
            aria-label="Открыть меню"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      ) : null}
      {children}
    </div>
  );
};

export default Main;
